// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import {DNA_COMPLEMENT_TABLE} from 'biojs/BioConstants';
import * as util from 'biojs/Util';
import {Sequence} from 'components/Sequence';
import * as CrisprConstants from 'constants/CRISPRConstants';
import {SequenceVersion} from 'constants/SequenceConstants';
import {HRTemplateColumn, TargetSite} from 'molbio/crispr/hr-template/HRTemplateStore';
import * as sequtil from 'molbio/SeqUtil';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Clipboard from 'ui-library/Clipboard';

import EditsTable from './EditsTable';
// @ts-expect-error
import highlightMutant from './highlightMutant';
import HRTemplateActions from './HRTemplateActions';

const {HR_TEMPLATE_STEP, HR_TEMPLATE_TAB_ID} = CrisprConstants;

interface Props {
  sequence: Sequence;
  pam: string;
  targetSite?: TargetSite;
  savedVersions: {[step in CrisprConstants.HRTemplateStep]: SequenceVersion & {bases: string}};
  guide: string;
  armRegion: {
    start: number;
    end: number;
  };
  columns?: Array<HRTemplateColumn>;
  isHRTemplateLoading: boolean;
  resettingToVersion: boolean;
  originalBases?: string;
}

class SummaryStep extends React.Component<Props> {
  override componentDidMount(): void {
    HRTemplateActions.setGuide(this.props.sequence.id);
    this.props.sequence.addLockingTab({tabId: HR_TEMPLATE_TAB_ID, tabName: 'HR template design'});
  }

  override render(): JSX.Element {
    let bases;
    const beforeRemovalBases = this.props.savedVersions[HR_TEMPLATE_STEP.REMOVE_TARGET_SITE].bases;
    return (
      <form>
        <fieldset>
          <legend>Step 4: Summary</legend>
          <FormGroup>
            <Row>
              <Col sm={12}>
                <EditsTable
                  currentBases={this.props.savedVersions[HR_TEMPLATE_STEP.SELECT_ARMS].bases}
                  originalBases={this.props.savedVersions[HR_TEMPLATE_STEP.INTRODUCE_EDITS].bases}
                  sequence={this.props.sequence}
                  offset={this.props.armRegion.start}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <dl className="dl-horizontal u-no-spacing-top">
                  <dt className="u-small-spacing-bottom">Template Range</dt>
                  <dd>
                    {sequtil.modelStartToDisplay(
                      this.props.armRegion.start,
                      this.props.sequence.startIndex()
                    )}
                    {' to '}
                    {sequtil.modelEndToDisplay(
                      this.props.armRegion.end,
                      this.props.savedVersions[HR_TEMPLATE_STEP.SELECT_ARMS].bases.length,
                      this.props.sequence.startIndex()
                    )}
                  </dd>
                  {this.props.guide.length > 0 ? (
                    <div>
                      <dt className="u-small-spacing-bottom">Guide</dt>
                      <dd className="mono">{this.props.guide}</dd>
                      <dt>Original Target Site</dt>
                      <dd className="mono">
                        {this.props.columns != null
                          ? [
                              '...',
                              this.props.columns.map(({start, end}, i) => {
                                bases = beforeRemovalBases.slice(start, end);
                                return (
                                  <span key={`${i}`} className="u-tiny-spacing-left u-tiny-spacing-right">
                                    {highlightMutant(
                                      bases,
                                      bases,
                                      start,
                                      this.props.targetSite,
                                      this.props.pam
                                    )}
                                  </span>
                                );
                              }),
                              '...',
                            ]
                          : 'Loading...'}
                      </dd>
                      <dt>After Site Removal</dt>
                      <dd className="mono">
                        {this.props.columns != null
                          ? [
                              '...',
                              this.props.columns.map(({start, end}, i) => (
                                <span key={`${i}`} className="u-tiny-spacing-left u-tiny-spacing-right">
                                  {highlightMutant(
                                    beforeRemovalBases.slice(start, end),
                                    this.props.sequence.residueSlice(start, end),
                                    start,
                                    this.props.targetSite,
                                    this.props.pam
                                  )}
                                </span>
                              )),
                              '...',
                            ]
                          : 'Loading...'}
                      </dd>
                    </div>
                  ) : undefined}
                </dl>
              </Col>
            </Row>
            <div className="well">
              <p>
                <Clipboard value={this.props.sequence.bases()}>
                  <a>Copy the template</a>
                </Clipboard>
                {' or its '}
                <Clipboard value={util.revcomp(this.props.sequence.bases(), DNA_COMPLEMENT_TABLE)}>
                  <a>reverse complement</a>
                </Clipboard>
                {' to your clipboard.'}
              </p>
              <div>
                {'To design a template for the same knock-in edits but with a different guide, '}
                <a
                  onClick={HRTemplateActions.designWithNewGuide.bind(
                    null,
                    this.props.sequence.id,
                    this.props.originalBases
                  )}
                >
                  click here
                </a>
                .
              </div>
            </div>
          </FormGroup>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.SMALL}
            onClick={HRTemplateActions.backToStep.bind(
              null,
              this.props.sequence.id,
              HR_TEMPLATE_STEP.REMOVE_TARGET_SITE
            )}
            disabled={this.props.isHRTemplateLoading || this.props.resettingToVersion}
            text={
              this.props.isHRTemplateLoading
                ? 'Loading...'
                : this.props.resettingToVersion
                  ? 'Resetting...'
                  : 'Back'
            }
          />
        </fieldset>
      </form>
    );
  }
}

export default SummaryStep;
